import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { Card, Flex, Typography } from "antd";

type Props = {
  label: string;
  value: string | number;
  meta?: string;
  emphasis?: "danger" | "default";
  delta?: number | null;
};

const PulseCard = ({ label, value, meta, emphasis, delta }: Props) => (
  <Card style={{ background: "#f7f8fa", borderColor: "#e5e7eb", height: "100%" }}>
    <Flex vertical align="center" gap={6}>
      <Typography.Text style={{ fontSize: 13, color: "#4b5563", textAlign: "center" }}>{label}</Typography.Text>
      <Typography.Title
        level={2}
        style={{
          margin: 0,
          color: emphasis === "danger" ? "#b91c1c" : "#0b1020",
          letterSpacing: "-0.02em",
        }}
      >
        {value}
      </Typography.Title>
      {typeof delta === "number" && delta !== 0 ? (
        <Flex align="center" gap={4}>
          {delta > 0 ? (
            <ArrowUpOutlined style={{ color: "#059669", fontSize: 11 }} />
          ) : (
            <ArrowDownOutlined style={{ color: "#dc2626", fontSize: 11 }} />
          )}
          <Typography.Text style={{ fontSize: 11, color: delta > 0 ? "#059669" : "#dc2626", fontWeight: 500 }}>
            {Math.abs(delta)} pts
          </Typography.Text>
        </Flex>
      ) : null}
      {meta ? (
        <Typography.Text style={{ fontSize: 11, color: "#6b7280", textAlign: "center" }}>{meta}</Typography.Text>
      ) : null}
    </Flex>
  </Card>
);

export default PulseCard;
